// src/hooks/useFetchToken.ts
import { useState } from 'react';
import { DeployToken } from '../interfaces';
import config from '../config';
import { useSession } from '../contexts/SessionContext';

const useFetchToken = () => {
  const [token, setToken] = useState<DeployToken | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { sessionState } = useSession();

  const fetchToken = async () => {
    const sessionToken = sessionState.account?.token;
    if (!sessionToken) {
      setError('Login or token is missing');
      return;
    }

    try {
      const response = await fetch(`${config.centralApiBaseUrl}/token`, {
        headers: {
            'Access-Control-Allow-Origin': '*',
          'Authorization': `Bearer ${sessionToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch token');
      }

      const data = await response.json();
      setToken(data);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
      setToken(null);
    }
  };

  return { token, error, fetchToken };
};

export default useFetchToken;
